import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import { SOCKET_URL } from "@Shared/@Utils/constants";
export class WebsocketClient {
  constructor(vm, config) {
    _defineProperty(this, "socket", void 0);
    _defineProperty(this, "token", void 0);
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "storeName", void 0);
    _defineProperty(this, "authSession", void 0);
    _defineProperty(this, "pingInterval", void 0);
    this.storeName = (config == null ? void 0 : config.storeName) || "WebsocketStore";
    this.authSession = vm.instance.$vm.$auth;
  }
  localStoreState() {
    return this.store.state[this.storeName];
  }
  commitToStore(type, payload) {
    if (this.store) {
      this.store.commit(`${this.storeName}/${type}`, payload);
    }
  }
  reconnect(token) {
    this.token = token;
  }
  disconnect() {
    if (this.localStoreState().isConnected) {
      this.commitToStore("SOCKET_ONCLOSE");
      this.socket.close();
    }
  }
  passToStoreHandler(store, event) {
    if (event.data) {
      var _context, _msg$mutation;
      const msg = JSON.parse(event.data);
      if (msg.type === "ping") {
        return;
      }
      const method = msg.mutation ? "commit" : "dispatch";
      const target = this.storeName + "/" + _filterInstanceProperty(_context = [msg.namespace || "", (_msg$mutation = msg.mutation) != null ? _msg$mutation : msg.action]).call(_context, e => !!e).join("/");
      if (method === "commit") {
        store[method](target, msg);
      } else {
        store[method](target, msg);
      }
    }
  }
  connect(token, store = this.store) {
    this.store = store;
    this.token = token;
    this.socket = new WebSocket(SOCKET_URL + `?token=${token}`);
    this.socket.onopen = () => {
      this.commitToStore("SOCKET_ONOPEN");
      this.pingInterval = setInterval(() => {
        this.socket.send(_JSON$stringify({
          type: "ping"
        }));
      }, WebsocketClient.PING_INTERVAL);
    };
    this.socket.onmessage = event => {
      this.commitToStore("SOCKET_ONMESSAGE", event);
      this.passToStoreHandler(this.store, event);
    };
    this.socket.onclose = () => {
      this.commitToStore("SOCKET_ONCLOSE");
      clearInterval(this.pingInterval);
      if (this.localStoreState().retry > 5) {
        this.commitToStore("SOCKET_RECONNECT_ERROR");
      } else {
        setTimeout(async () => {
          await this.authSession.renew();
        }, 1000);
      }
    };
  }
}
_defineProperty(WebsocketClient, "PING_INTERVAL", 20000);
const websocketAdapter = {
  instance: undefined,
  config: undefined,
  init(Vue) {
    this.instance = new WebsocketClient(Vue, this.config);
  },
  get socket() {
    return this.instance;
  },
  disconnect() {
    var _this$instance;
    return (_this$instance = this.instance) == null ? void 0 : _this$instance.disconnect();
  },
  async reconnect(token) {
    var _this$instance2;
    return (_this$instance2 = this.instance) == null ? void 0 : _this$instance2.reconnect(token);
  },
  async connect(...args) {
    var _this$instance3;
    return (_this$instance3 = this.instance) == null ? void 0 : _this$instance3.connect(...args);
  }
};
export const WebsocketPlugin = {
  install(Vue, options) {
    Vue.socket = websocketAdapter;
    Vue.socket.config = options;
    _Object$defineProperties(Vue.prototype, {
      $socket: {
        get() {
          return Vue.socket;
        }
      }
    });
  }
};